import * as React from "react";
const DistributeCenter = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16 10H9a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1Zm5-5V4H4v1h17ZM9 9h7a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2Zm12 11v1H4v-1h17Z" }));
DistributeCenter.displayName = "DistributeCenter";
var DistributeCenter_default = DistributeCenter;
export {
  DistributeCenter_default as default
};
